
const getters = {
  /*
  users api getters
  */
  username: state => state.users.username,
  userInfo: state => state.users.userInfo,
  token: state => state.users.token,
  roles: state => state.users.roles,
  permissionToken: state => state.users.permissionToken,
  privilage: state => state.users.privilage,
  privilageGrade: state => state.users.privilage_grade,
  labInfo: state => state.users.labInfo,
  labPrivilage: state => state.users.labPrivilage,
  processSaveStatus: state => state.users.processSaveStatus,
  globalMessage: state => state.users.globalMessage,
  globalMessageMaxValue: state => state.users.globalMessageMaxValue,
  /*
  route getters
  */
  allRoutes: state => state.routes.allRoutes,
  projectRoutes: state => state.routes.projectRoutes,
  adminRoutes: state => state.routes.adminRoutes,
  addRouters: state => state.routes.addRouters,
  /*
  home api getters
  */
  sliderBarState: state => state.home.sliderBarState,
  minHeight: state => state.home.minHeight,
  primaryColor: state => state.home.primaryColor,
  sliderBarActiveIndex: state => state.home.sliderBarActiveIndex,
  /*
  project getters
  */
  labList: state => state.project1.labList,
  organizationList: state => state.project1.organizationList,
  projectList: state => state.project1.projectList,
  projectPrivateList: state => state.project1.privateList,
  projectListNum: state => state.project1.projectListNum,
  projectDetail: state => state.project1.projectDetail,
  /*
  ums
  */
  // lab
  listLab: state => state.lab.listLab,
  labListNum: state => state.lab.labListNum,
  labDetail: state => state.lab.labDetail,
  mapDetail: state => state.lab.mapDetail,
  // audit
  auditLabList: state => state.audit.auditLabList,
  auditLabListTotal: state => state.audit.auditLabListTotal,
  /*
  samples api getters
  */
  allSourceType: state => state.samples.allSourceType,
  rootClassification: state => state.samples.rootClassification,
  species: state => state.samples.species,
  sampleTableList: state => state.samples.sampleTableList,
  sampleType: state => state.samples.sampleType,
  sampleSubmitDisabled: state => state.samples.sampleSubmitDisabled,
  samplesFormList: state => state.samples.list,
  sampleRootId: state => state.samples.rootId,
  sampleFormValue: state => state.samples.formValue,
  samTissueFormList: state => state.samples.tissueFormList,
  samCellFormList: state => state.samples.cellFormList,
  samOrganFormList: state => state.samples.organelleFormList,
  draftSampleTableList: state => state.samples.draftShowSampleTableList,
  allStrain: state => state.samples.allStrain,
  /*
  reagent
  */
  reagentList: state => state.reagent.reagentList,
  CvReagentTypeList: state => state.reagent.CvReagentTypeList,
  reagentManufacturerList: state => state.reagent.reagentManufacturerList,
  addInfoList: state => state.reagent.CvReagentTypeList,
  reagentDetail: state => state.reagent.reagentDetail,
  reagentApplicationList: state => state.reagent.reagentApplicationList,
  conjugateList: state => state.reagent.conjugateList,
  /*
  experiment
  */
  experimentActiveIndex: state => state.experiments.experimentActiveIndex,
  expSubList: state => state.experiments.subList,
  createExpSubList: state => state.experiments.createSubList,
  expCode: state => state.experiments.draftGeneralCode,
  subcellularOrganelleList: state => state.experiments.subcellularOrganelleList,
  proteomicsProtocolList: state => state.experiments.proteomicsProtocolList,
  // drafts exp getters
  createEmptyList: state => state.experiments.createSubList,
  expGeneralList: state => state.experiments.generalList,
  expSamList: state => state.experiments.sampleList,
  expPrepList: state => state.experiments.prepFormList,
  expSepList: state => state.experiments.sepFormList,
  expDigList: state => state.experiments.digFormList,
  expInsList: state => state.experiments.insFormList,
  expComList: state => state.experiments.comments,
  expMSFormList: state => state.experiments.msList,
  // modify exp getters
  modifyExpGeneralList: state => state.experiments.modifyGeneralList,
  modifyExpSamList: state => state.experiments.modifySampleList,
  modifyExpPrepList: state => state.experiments.modifyPrepFormList,
  modifyExpSepList: state => state.experiments.modifySepFormList,
  modifyExpDigList: state => state.experiments.modifyDigFormList,
  modifyExpInsList: state => state.experiments.modifyInsFormList,
  modifyExpMsList: state => state.experiments.modifyMsList,
  modifyComList: state => state.experiments.modifyComments,
  modifyExpSubList: state => state.experiments.modifySubList,
  expSamNextButton: state => state.experiments.samNextDisabled,
  expSamDraftsButton: state => state.experiments.samDraftsDisabled,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  // dbsearch
  databaseNameList: state => state.experiments.databaseNameList,
  dynamicCvList: state => state.experiments.dynamicCvList,
  dbFormList: state => state.samples.list,
  localMascotBaseName: state => state.search.localMascotBaseName,
  // AnalysisI
  proteinIdFilterArr: state => state.analysisI.proteinIdFilterArr
}

export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js